"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function SitemapLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-1">
        <li className="h-6 w-20 bg-background/10 animate-pulse" />
        <li className="h-6 w-24 bg-background/10 animate-pulse" />
        <li className="h-6 w-16 bg-background/10 animate-pulse" />
      </ul>;
  }
  return <ul className="flex flex-col" style={{
    lineHeight: 2.2
  }}>
      {menuItems.map((item, i) => <li key={item.id} data-index={i} className="text-[0.8125rem] font-medium tracking-[0.01em]">
          <Link to={item.href || "#"} className="text-foreground hover:text-primary transition-colors duration-200 inline-block relative group">
            <span className="border-b border-transparent group-hover:border-primary transition-colors duration-200 pb-0.5">
              {item.label}
            </span>
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const businessName = "Inclusive Voices News";
  const address = "100 Civic Plaza, Suite 400, Metropolitan Area, 90210";
  const email = "editorial@inclusivevoices.news";
  const phone = "+1 800-555-0199";
  const socials = [{
    label: "Twitter",
    href: "#"
  }, {
    label: "LinkedIn",
    href: "#"
  }, {
    label: "Instagram",
    href: "#"
  }];
  const legalLinks = [{
    label: "Terms",
    href: "#"
  }, {
    label: "Privacy",
    href: "#"
  }];
  return <section data-section-id="15193" id="site-footer" className="dark bg-background text-foreground px-5 md:px-16 py-20 md:py-28 font-default">
      {}
      <div className="w-full h-px bg-border" />

      {}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 py-16">
        {}
        <div className="md:col-span-3 flex flex-col gap-4">
          <h3 className="text-foreground font-default" style={{
          fontSize: "clamp(1.375rem, 1.9vw, 1.75rem)",
          fontWeight: 700,
          letterSpacing: "-0.012em",
          lineHeight: 1.18
        }}>
            {businessName}
          </h3>
          <p className="text-muted-foreground text-base leading-relaxed">
            {address}
          </p>
        </div>

        {}
        <div className="md:col-span-3 flex flex-col gap-4">
          <h4 className="text-foreground text-[1.0625rem] font-semibold tracking-normal font-default">
            Navigation
          </h4>
          <MenuProvider menu_id="32">
            <SitemapLinks />
          </MenuProvider>
        </div>

        {}
        <div className="md:col-span-3 flex flex-col gap-4">
          <h4 className="text-foreground text-[1.0625rem] font-semibold tracking-normal font-default">
            Contact
          </h4>
          <ul className="flex flex-col" style={{
          lineHeight: 2.2
        }}>
            <li className="text-[0.8125rem] font-medium tracking-[0.01em]">
              <Link to={`mailto:${email}`} className="text-foreground hover:text-primary transition-colors duration-200 inline-block group">
                <span className="border-b border-border group-hover:border-primary transition-colors duration-200 pb-0.5">
                  {email}
                </span>
              </Link>
            </li>
            <li className="text-[0.8125rem] font-medium tracking-[0.01em] text-muted-foreground">
              {phone}
            </li>
          </ul>
        </div>

        {}
        <div className="md:col-span-3 flex flex-col gap-4">
          <h4 className="text-foreground text-[1.0625rem] font-semibold tracking-normal font-default">
            Connect
          </h4>
          <ul className="flex flex-col" style={{
          lineHeight: 2.2
        }}>
            {socials.map((social, i) => <li key={social.label} data-index={i} className="text-[0.8125rem] font-medium tracking-[0.01em]">
                <Link to={social.href} newTab className="text-foreground hover:text-primary transition-colors duration-200 inline-block group">
                  <span className="border-b border-transparent group-hover:border-primary transition-colors duration-200 pb-0.5">
                    {social.label}
                  </span>
                </Link>
              </li>)}
          </ul>
        </div>
      </div>

      {}
      <div className="w-full h-px bg-border" />

      {}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8">
        <div className="md:col-span-6">
          <p className="text-[0.8125rem] font-medium tracking-[0.01em] text-muted-foreground">
            {"\u00A9 Inclusive Voices News 2025. Diversity is our strength."}
          </p>
        </div>
        <div className="md:col-start-10 md:col-span-3 flex md:justify-end gap-6">
          {legalLinks.map((link, i) => <Link key={link.label} to={link.href} data-index={i} className="text-[0.8125rem] font-medium tracking-[0.01em] text-muted-foreground hover:text-primary transition-colors duration-200 group">
              <span className="border-b border-transparent group-hover:border-primary transition-colors duration-200 pb-0.5">
                {link.label}
              </span>
            </Link>)}
        </div>
      </div>
    </section>;
}